module.exports = __webpack_public_path__ + "static/img/LT.d0cbea58.png";